import React, { Component } from "react";
import constants from "../../constants";
import axios from "axios";
import { toast } from "react-toastify";
import {formatCPF, validateCpf} from '../Util/util'
class ForgetPasswordView extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = { error: false,success:false };
  }
  formatingCpf(value){
    this.refs.cpf.value = formatCPF(value)
  }
  handleSubmit(event) {
    event.preventDefault();

    const email = this.refs.email.value;
    const cpf = this.refs.cpf.value;
    const password = this.refs.password.value;
    const password2 = this.refs.password2.value;
    const recovery_password = constants().URL_SERVICE + "account/manager/recovery_password/";
    if(!(password === password2)){
      return;
    }
    axios
      .post(recovery_password, {
        email,cpf,password
      })
      .then(response => {
        this.setState({ error: false,success:true })
        this.refs.email.value = ""
        this.refs.cpf.value = ""
        this.refs.password.value = ""
        this.refs.password2.value = ""

        toast.success("Solicitação efetuada com sucesso!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
        // localStorage.setItem("token", response.data.token);
        // localStorage.setItem("establishment_name", response.data.estab_name);
        // localStorage.setItem("establishment_img", response.data.estab_picture ? response.data.estab_picture : "");
        // this.props.router.replace("/");
      })
      .catch(error => {
        this.setState({ error: true,success:false })
        toast.error("Por Favor Verifique seu Email",{
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
      });
  }

  render() {
    return (
      <div className="app app-header-fixed">
        <div className="container w-xxl w-auto-xs">
          <span className="navbar-brand block m-t">Allfast Admin</span>
          {/* <div className="wrapper text-center">
            Por favor, Digite seu Email de Usuário.
          </div> */}
          <div className="m-b-lg">
            <div className="wrapper text-center">
              <form
                name="form"
                className="form-validation"
                onSubmit={this.handleSubmit}
              >
                  
                {this.state.error ? (
                  <div className="text-danger wrapper text-center">
                    Por favor, verifique suas Informações.
                  </div>
                ) : (
                  ""
                )}

                {this.state.success ? (
                  <div className="text-success wrapper text-center">
                    Solicitação Efetuada com Sucesso
                  </div>
                ) : (
                  ""
                )}

                <div className="list-group list-group-sm">
                  <div className="list-group-item">
                    
                    <input
                      type="email"
                      placeholder="Email"
                      className="form-control no-border"
                      required
                      ref="email"
                    />
                  </div>
                  <div className="list-group-item">
                    
                    <input
                      type="text"
                      className="form-control no-border"
                      placeholder="CPF"
                      required
                      ref="cpf"
                      onChange={(e)=>this.formatingCpf(e.target.value)}
                    />
                  </div>
                  <div className="list-group-item">
                    
                    <input
                      type="password"
                      placeholder="Nova Senha"
                      className="form-control no-border"
                      required
                      ref="password"
                    />
                  </div>
                  <div className="list-group-item">
                    
                    <input
                      type="password"
                      placeholder="Repita Nova senha"
                      className="form-control no-border"
                      required
                      ref="password2"
                    />
                  </div>
                </div>
                <button type="submit" className="btn btn-lg btn-block">
                  Enviar
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ForgetPasswordView;



// WEBPACK FOOTER //
// ./src/views/ForgetPassword/index.js